import {
  ProductFullResponse,
  ProductFullStoreEnum,
} from "definitions/shihuo-api";
import { API } from "src/api";

import { parseShihuoExternalId } from "./shihuoSizePrices";

export const loadShihuoProductFull = async (
  externalId: string,
): Promise<ProductFullResponse | undefined> => {
  const ids = parseShihuoExternalId(externalId);

  if (!ids) return undefined;

  const response = await API.shihuoApi.productFull(
    ids.goodsId,
    ids.styleId,
    undefined,
    undefined,
    ProductFullStoreEnum.All,
  );

  return response.data;
};
